import { Brand } from "src/api-service";
import { AppError } from "../../app-store-error.types";
import { DEFAULT_VENDOR_LIST_VISIBLE_COLUMNS } from "src/app/pages/home/page/vendors/components/vendors-table/vendors.columns";

// **************************************************************************
// VENDOR STATE
// **************************************************************************

export interface VendorState {
    vendors: Brand[];
    // List UI state
    loaded: boolean;
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    sortProperty: string;
    sortAscending: boolean;
    searchFilter: string;
    visibleColumns: string[];
    // Loading
    loadingList: boolean;
    // Error
    error: AppError | null;
}

export const initialVendorState: VendorState = {
    vendors: [],
    // List UI state
    loaded: false,
    pageNumber: 1,
    pageSize: 50,
    totalCount: 0,
    sortProperty: "name",
    sortAscending: true,
    searchFilter: "",
    visibleColumns: DEFAULT_VENDOR_LIST_VISIBLE_COLUMNS,
    // Loading
    loadingList: false,
    // Error
    error: null,
};
